import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs/index';
import { GatewayState } from './gateway.reducer';

const sharedNumbersSelector = (state: GatewayState) => (state as any).gateway.sharedNumbers;

@Injectable({
    providedIn: 'root' // No need to provide in AppModule, and now tree shakable
})
export class GatewaySelectors {

    constructor(private store: Store<any>) {
    }

    selectSharedNumber(): Observable<Array<string>> {
        return this.store.pipe(select(sharedNumbersSelector));
    }
}
